import { useState } from 'react';
import { IconButton, ListItemButton, Typography } from '@mui/material';

import DeleteDialog from 'Lib/muiComponents/dialog/DeleteDialog';

export default function TableRowDelete({ data, button, onDelete, setAnchorElement }) {
    const [open, setOpen] = useState(false);

    const toggleModal = () => {
        if (open && setAnchorElement) setAnchorElement(null);
        setOpen(prevState => !prevState);
    };

    return (
        <>
            {button ? (
                <IconButton onClick={toggleModal}>delete</IconButton>
            ) : (
                <ListItemButton onClick={toggleModal}>
                    <Typography>Delete</Typography>
                </ListItemButton>
            )}
            <DeleteDialog data={data} open={open} onDelete={onDelete} toggle={toggleModal}>
                Are you sure you want to delete this item?
            </DeleteDialog>
        </>
    );
}
